import { SOURCES_BY_ISLAND, ALL_SOURCES } from "../lib/constants";
import { useT } from "../lib/LangContext";
import { openSubscribe } from "./SubscribeModalHost";
import { useIsSubscribed } from "../lib/useIsSubscribed";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { DigestLaunchNotice } from "./DigestLaunchNotice";

// Placement 3 — Sidebar Widget. Dark #1A2E35 card, WhatsApp icon
// centered top, headline + subheadline centered, full-width green
// "Join Free on WhatsApp →" button.
export const WhatsAppCTA = () => {
  const isSubscribed = useIsSubscribed();
  const { t } = useT();
  if (isSubscribed) return null;
  return (
    <div
      className="rounded-xl bg-[#1A2E35] p-5 text-white text-center"
      data-testid="sidebar-whatsapp-cta"
    >
      <div className="flex justify-center mb-3">
        <WhatsAppIcon size={32} className="text-[#25D366]" />
      </div>
      <h3 className="text-white text-[15px] font-bold mb-2 leading-snug">
        {t("digest_cta_headline")}
      </h3>
      <p className="text-white/70 text-[11px] mb-3 leading-snug">
        {t("digest_cta_sub")}
      </p>
      <DigestLaunchNotice
        tone="dark"
        className="text-left"
        testid="sidebar-whatsapp-cta-launch-notice"
      />
      <button
        type="button"
        onClick={() => openSubscribe("sidebar")}
        className="w-full py-2.5 rounded-lg bg-[#25D366] hover:bg-[#1fb954] text-white text-sm font-bold transition-colors mt-3"
        data-testid="sidebar-subscribe-btn"
      >
        {t("digest_cta_button_wa")}
      </button>
    </div>
  );
};

export const SourceTiles = ({ island = "all" }) => {
  const { t } = useT();
  const sources = island === "all" ? ALL_SOURCES : SOURCES_BY_ISLAND[island] || ALL_SOURCES;
  return (
    <div className="card-soft p-5" data-testid="source-tiles">
      <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] mb-4">
        {t("news_sources")}
      </h3>
      <div className="grid grid-cols-2 gap-2">
        {sources.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#FAFAFA] hover:bg-[#F0F0F0] transition-colors"
            data-testid={`source-tile-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <span className="w-1.5 h-1.5 rounded-full flex-shrink-0 bg-[#0AADA0]" />
            <span className="text-xs text-[#1A1A1A] truncate">{s.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};
